import React from 'react'

const ArrowNew = ({ fill, style={} }) => {
  return (
    <>
        <svg width="12" height="7" viewBox="0 0 12 7" fill="none" xmlns="http://www.w3.org/2000/svg" style={style}>
        <path d="M1 1.5L6 5.5L11 1.5" stroke={fill} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    </>
  )
}

export default ArrowNew